import CreditCard from "@heroicons/react/24/solid/CreditCardIcon";
import GridIcon from "@heroicons/react/24/solid/TableCellsIcon";
import { SvgIcon, ToggleButtonGroup, Typography } from "@mui/material";
import { Fragment } from "react";
import StyledToggleButton from "shared/ui/ToggleButton";

export enum ETemplateViewTypes {
  Card = "Card",
  Grid = "Grid",
}

const TemplateViewTypes = ({
  type,
  setType,
}: {
  type: ETemplateViewTypes;
  setType: (type: ETemplateViewTypes) => void;
}) => {
  const chooseType = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: ETemplateViewTypes | null
  ) => {
    if (newAlignment !== null) {
      setType(newAlignment);
    }
  };

  return (
    <Fragment>
      <ToggleButtonGroup
        value={type}
        exclusive
        onChange={chooseType}
        aria-label="text alignment"
      >
        <StyledToggleButton
          value={ETemplateViewTypes.Card}
          selected={type === ETemplateViewTypes.Card}
        >
          <SvgIcon fontSize="small">
            <CreditCard />
          </SvgIcon>
          <Typography sx={{ marginLeft: 1 }}>Card</Typography>
        </StyledToggleButton>
        <StyledToggleButton
          value={ETemplateViewTypes.Grid}
          selected={type === ETemplateViewTypes.Grid}
        >
          <SvgIcon fontSize="small">
            <GridIcon />
          </SvgIcon>
          <Typography sx={{ marginLeft: 1 }}>Grid</Typography>
        </StyledToggleButton>
      </ToggleButtonGroup>
    </Fragment>
  );
};

export default TemplateViewTypes;
